import MuiTable, { TableProps as MuiTableProps } from '@mui/material/Table';
import MuiTableBody, { TableBodyProps as MuiTableBodyProps } from '@mui/material/TableBody';
import MuiTableCell, { TableCellProps as MuiTableCellProps } from '@mui/material/TableCell';
import MuiTableContainer, { TableContainerProps as MuiTableContainerProps } from '@mui/material/TableContainer';
import MuiTableFooter, { TableFooterProps as MuiTableFooterProps } from '@mui/material/TableFooter';
import MuiTableHead, { TableHeadProps as MuiTableHeadProps } from '@mui/material/TableHead';
import MuiTableRow, { TableRowProps as MuiTableRowProps } from '@mui/material/TableRow';

import React from 'react';

interface TableProps extends MuiTableProps {}
interface TableBodyProps extends MuiTableBodyProps {}
interface TableFooterProps extends MuiTableFooterProps {}
interface TableCellProps extends MuiTableCellProps {}
interface TableContainerProps extends MuiTableContainerProps {
	component?: React.ElementType;
}
interface TableHeadProps extends MuiTableHeadProps {}
interface TableRowProps extends MuiTableRowProps {}

export const Table = (props: TableProps) => {
	return <MuiTable {...props} />;
};

export const TableBody = (props: TableBodyProps) => {
	return <MuiTableBody {...props} />;
};

export const TableFooter = (props: TableFooterProps) => {
	return <MuiTableFooter {...props} />;
};

export const TableCell = (props: TableCellProps) => {
	return <MuiTableCell {...props} />;
};

export const TableContainer = (props: TableContainerProps) => {
	return <MuiTableContainer {...props} />;
};

export const TableHead = (props: TableHeadProps) => {
	return <MuiTableHead {...props} />;
};

export const TableRow = (props: TableRowProps) => {
	return <MuiTableRow {...props} />;
};
